import { SliderRange } from 'projects/common/components/slider-range/slider-range.component';
import { InputType } from '../form/inputs.model';

export interface OffersFilterData {
  city_gid: string;
  show_origin: boolean;
  filters: { [key: string]: Filter };
  showEmptyState: boolean;
  default_origin: string;
  show_all_filters: boolean;
  use_modal: boolean;
  sorting_options: OfferSortingOption[];
  default_sorting_id?: string;
}

export interface OfferSortingOption {
  id: string;
  name: string;
  selected: boolean;
}

export interface BaseFilter {
  name: string;
  description?: string;
  selected?: Record<string, SliderRange>;
  hasSelection: boolean;
  active: boolean; // aplicado
  search_type?: FilterType;
  highlight?: boolean;
  hidden?: boolean;
  forceHidden?: boolean;
  group_id?: string;
  view_more_link_text?: string;
}

export interface RangeFilter extends BaseFilter {
  type: 'range';
  value: { [key: string]: FilterValue }; // value is used for single selector, multicurrency
  values?: { [key: string]: FilterValue }[]; // values is used for multiselector
  selected_values?: FilterValue[];
  value_type: 'FARE' | 'TIME' | 'DAYS';
  multiselector?: boolean;
}

export interface DiscreteFilter extends BaseFilter {
  type: 'discrete';
  values: FilterValue[];
  multiselector: boolean;
}

export interface InputFilter extends BaseFilter {
  type: 'input';
  value: string;
  placeholder: string;
  input_type: InputType;
}

export type Filter = RangeFilter | DiscreteFilter | InputFilter;

export interface FilterValue {
  id: string;
  name: string;
  amount: number;
  description?: string;
  highlight?: boolean;
  min: number;
  max: number;
  minTime?: string;
  maxTime?: string;
  step: number;
  selected: boolean;
  all_items_choice: boolean;
  icon_src?: string;
  icon_name?: string;
  disabled?: boolean;
}

export interface FilterActionsState {
  showRemove: boolean;
  showApplyEnabled: boolean;
}

export enum FilterType {
  CITY = "CITY", MONTH = "MONTH", INPUT = "INPUT"
}
